import PropTypes from 'prop-types';
import { Icon, Push } from '@bwoty-web/ui-kit';
import { UI_ARROW_RIGHT } from '@bwoty-web/ui-kit/icons';
import { useIsGlobetrotter } from '@bwoty-web/ui-kit/hooks';

import './readMorePushes.scss';

const ReadMorePushes = ({
  routePopupOnClick,
  cruiseCompanyCode,
  cruiseShipId,
  cruiseCompanyId,
  labels,
}) => {
  const isGlobetrotter = useIsGlobetrotter();
  const faqsUrl = isGlobetrotter
    ? `${labels.readMoreUrls.faqs[cruiseCompanyCode]}?pageTemplate=popUpPage&qf=popUpPage`
    : `${labels.readMoreUrls.faq}?cruiseCompanyId=${cruiseCompanyId}&pageTemplate=popUpPage&qf=popUpPage`;
  return (
    <div className="gw-cruise-description-readMore">
      {routePopupOnClick && (
        <button
          type="button"
          onClick={routePopupOnClick}
          className="gw-cruise-description-readMore__route-popup-button"
        >
          {labels?.routePopupButtonText}
          <Icon path={UI_ARROW_RIGHT} size="xs" />
        </button>
      )}
      <Push
        href={`${labels.readMoreUrls.ship}?shipId=${cruiseShipId}&pageTemplate=popUpPage&qf=popUpPage`}
      >
        {labels.readMoreShip}
      </Push>
      <Push
        href={`${labels.readMoreUrls.shippingCompanies[cruiseCompanyCode]}?pageTemplate=popUpPage&qf=popUpPage`}
      >
        {labels.readMoreShippingCompany}
      </Push>
      <Push href={faqsUrl}>{labels.readMoreImportantInfo}</Push>
    </div>
  );
};

ReadMorePushes.propTypes = {
  routePopupOnClick: PropTypes.oneOfType([PropTypes.bool, PropTypes.func])
    .isRequired,
  cruiseCompanyCode: PropTypes.oneOf(['O', 'C', 'N', 'R']).isRequired,
  cruiseShipId: PropTypes.number.isRequired,
  cruiseCompanyId: PropTypes.number.isRequired,
  labels: PropTypes.shape({
    routePopupButtonText: PropTypes.string,
    readMoreUrls: PropTypes.shape({
      shippingCompanies: PropTypes.shape({}),
      faqs: PropTypes.shape({}),
      ship: PropTypes.string,
      faq: PropTypes.string,
    }),
    readMoreShip: PropTypes.string,
    readMoreShippingCompany: PropTypes.string,
    readMoreImportantInfo: PropTypes.string,
  }).isRequired,
};

export default ReadMorePushes;
